import React from 'react';
import { connect } from 'react-redux';

import { find as _find, forEach as _forEach } from 'lodash';
import ReactDOM from 'react-dom';
import {Button, ButtonGroup, Col, Form, FormControl, FormText, Row} from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import withRouter from 'js/withRouter';
import { injectIntl } from 'react-intl';
import FormSwitchery from '../../../components/forms/FormSwitchery';
import { cloneDeep as _cloneDeep } from 'lodash';


const ContextModal = ({ children }) => {
  return ReactDOM.createPortal(children, document.getElementById('context-modal'));
};

class QRCodeElement extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      showQRGen: false,
      src: [],
      key: 0,
      QRBackgroundColor: '#FFFFFF',
      QRFontColor: '#000000',
      QRBackgroundColorCache: '#FFFFFF',
      QRFontColorCache: '#000000',
      QRMargin: true,
      QRMarginCache: true,
    };
    this.qrUrl = React.createRef();
    this.qrVCname = React.createRef();
    this.qrVCorg = React.createRef();
    this.qrVCposition = React.createRef();
    this.qrVCtel = React.createRef();
    this.qrVCmobile = React.createRef();
    this.qrVCurl = React.createRef();
    this.qrVCmail = React.createRef();
    this.qrVCadr = React.createRef();
    this.qrMailTo = React.createRef();
    this.qrMailTopic = React.createRef();
    this.qrMailText = React.createRef();
    this.qrText = React.createRef();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.params[0] && prevProps.params[0]?.value !== this.props.params[0]?.value) {
    this.getQRCodeData();
    }
  };

  getQRCodeData = () => {
    const { attributes, params, id, updateParam } = this.props;
    const param = _find(params, ['name', attributes['data-name']]);
    let output;

    let QRBackgroundColor;
    let QRFontColor;
    let QRMargin;


    if (typeof attributes['data-bg'] !== 'undefined') {
      this.setState({ QRBackgroundColor: attributes['data-bg'], QRBackgroundColorCache: attributes['data-bg'] });
      QRBackgroundColor = attributes['data-bg'];
    }else{
      this.setState({ QRBackgroundColor: '#FFFFFF', QRBackgroundColorCache: '#FFFFFF' });
      QRBackgroundColor = '#FFFFFF';
    }
    if (typeof attributes['data-color'] !== 'undefined') {
      this.setState({ QRFontColor: attributes['data-color'], QRFontColorCache: attributes['data-color'] });
      QRFontColor = attributes['data-color'];
    }else{
      this.setState({ QRFontColor: '#000000', QRFontColorCache: '#000000' });
      QRFontColor = '#000000';
    }
   if (typeof attributes['data-margin'] !== 'undefined' && attributes['data-margin'] === 'false') {
      this.setState({ QRMargin: false, QRMarginCache: false });
      QRMargin = attributes['data-margin'];
    }else{
      this.setState({ QRMargin: true, QRMarginCache: true });
      QRMargin = true;
    }

    if (param) {
      output = param.value.split('#cc#');
      if (output.length === 6) {
        this.setState({
          QRBackgroundColor: output[3],
          QRFontColor: output[4],
          QRMargin: output[5] !== 'false',
          QRBackgroundColorCache: output[3],
          QRFontColorCache: output[4],
          QRMarginCache: output[5] !== 'false',
        });
        QRBackgroundColor = output[3];
        QRFontColor = output[4];
        QRMargin = output[5] !== 'false';
      }
    }

    const initQR = attributes['data-qr'] || false;
    if (!param && initQR) {
      const overflow = false;
      const default_image = false;
      const errors = [{ overflow, default_image }];
      const output = initQR.split('#cc#');
      const srcOutput = this.parseQR(parseInt(output[0]), output[1].split('#vcc#'));

      if(id){
        updateParam(
          id,
          attributes['data-name'],
          parseInt(output[0]) +
          '#cc#' +
          srcOutput.srcString +
          '#cc#' +
          attributes['data-size'] +
          '#cc#' +
          QRBackgroundColor +
          '#cc#' +
          QRFontColor +
          '#cc#' +
          QRMargin,
          errors
        );
      }
    }
  }

  componentDidMount() {
    this.getQRCodeData();
  }

  updateQRBackgroundColor = color => {
    this.setState({ QRBackgroundColorCache: color });
  };

  updateQRFontColor = color => {
    this.setState({ QRFontColorCache: color });
  };

  updateQRMargin = (name, value) => {
    this.setState({ QRMarginCache: value });
  };

  changeQRCodeColor = option => {
    const { QRBackgroundColorCache, QRFontColorCache, QRMarginCache, savedGeneratedQRCodeData } = this.state;

    this.setState({
      QRBackgroundColor: QRBackgroundColorCache,
      QRFontColor: QRFontColorCache,
      QRMargin: QRMarginCache,
    }, () => {

      const { attributes, params, id, updateParam } = this.props;
      const param = _find(params, ['name', attributes['data-name']]);
      const initQR = attributes['data-qr'] || false;
      let output;
      if (param) {
        output = param.value.split('#cc#');
      }else if(!param && initQR){
        output = initQR.split('#cc#');
      }
        const overflow = false;
        const default_image = false;
        const errors = [{overflow, default_image}];
        const srcOutput = this.parseQR(parseInt(output[0]), output[1].split('#vcc#'));
        updateParam(
          id,
          attributes['data-name'],
          parseInt(output[0]) +
          '#cc#' +
          srcOutput.srcString +
          '#cc#' +
          attributes['data-size'] +
          '#cc#' +
          this.state.QRBackgroundColor +
          '#cc#' +
          this.state.QRFontColor +
          '#cc#' +
          this.state.QRMargin,
          errors
        );

    });
    this.setState({ showQRGen: false });
  };

  getSrc = () => {
    const { attributes, params } = this.props;
    const param = _find(params, ['name', attributes['data-name']]);
    const initQR = attributes['data-qr'] || false;
    if (param) {
      const output = param.value.split('#cc#');
      const srcOutput = output[1].split('#vcc#');
      return srcOutput[0];
    }
    if (initQR) {
      const output = initQR.split('#cc#');
      const srcOutput = output[1].split('#vcc#');
      return srcOutput[0];
    }

    return decodeURI('https://www.creacheck.com');
  };

  handleSelect(key) {
    this.setState({ key: parseInt(key) });
  }

  parseQR = (key, srcOutput) => {
    const src = [];

    let srcString = '';
    switch (key) {
      case 1:
        src.url = srcOutput[1];
        src.value = decodeURI(src.url);
        srcString = src.value + '#vcc#' + src.url;
        break;
      case 2:
        src.name = srcOutput[1];
        src.org = srcOutput[2];
        src.title = srcOutput[3];
        src.tel = srcOutput[4];
        src.url = srcOutput[5];
        src.mail = srcOutput[6];
        src.adr = srcOutput[7];
        src.mobile = srcOutput?.[8];
        src.value =
          'BEGIN:VCARD\nVERSION:3.0' +
          '\nN:' +
          src.name +
          '\nORG:' +
          src.org +
          '\nTITLE:' +
          src.title +
          '\nTEL:' +
          src.tel +
          '\nURL:' +
          decodeURI(src.url) +
          '\nEMAIL:' +
          src.mail +
          '\nADR:' +
          src.adr +
          '\nTEL;TYPE=cell:' +
          src.mobile +
          '\nEND:VCARD';
        srcString = src.value;
        srcString += '#vcc#' + src.name;
        srcString += '#vcc#' + src.org;
        srcString += '#vcc#' + src.title;
        srcString += '#vcc#' + src.tel;
        srcString += '#vcc#' + src.url;
        srcString += '#vcc#' + src.mail;
        srcString += '#vcc#' + src.adr;
        srcString += '#vcc#' + src.mobile;
        break;
      case 3:
        src.mail = srcOutput[1];
        src.topic = srcOutput[2];
        src.text = srcOutput[3];
        src.value =
          'MATMSG:TO:' + src.mail + ';SUB:' + decodeURIComponent(src.topic) + ';BODY:' + decodeURIComponent(src.text)+';;';
        srcString = src.value;
        srcString += '#vcc#' + src.mail;
        srcString += '#vcc#' + src.topic;
        srcString += '#vcc#' + src.text;
        break;
      case 4:
        src.text = srcOutput[1];
        src.value = src.text;
        srcString = src.value + '#vcc#' + src.text;
        break;
      default:
        src.value = 'http://www.creacheck.com';
        srcString = src.value;
        break;
    }
    return { src, srcString };
  };

  openQRGen = e => {
    const { attributes, params } = this.props;
    let src = [];
    src.src = [];
    src.src.url = 'https://www.creacheck.com';
    src.src.value = 'https://www.creacheck.com';
    let key = 1;
    const param = _find(params, ['name', attributes['data-name']]);
    const initQR = attributes['data-qr'];
    if (param || initQR) {
      let output;
      if (param) {
        output = param.value.split('#cc#');
      } else {
        output = initQR.split('#cc#');
      }
      key = parseInt(output[0]);
      src = this.parseQR(key, output[1].split('#vcc#'));
    }
    this.setState({
      showQRGen: true,
      src: src.src,
      key,
    });
  };

  handleQRclose = e => {
    this.setState({ showQRGen: false });
  };

  generateQR = () => {
    const { id, attributes, updateParam } = this.props;
    const { key } = this.state;
    const overflow = false;
    const default_image = false;
    const errors = [{ overflow, default_image }];
    let src;
    let srcString = '';
    let value = {};
    let _key = parseInt(key);

    switch (_key) {
      case 1: // url
        value = this.parseQR(key, ['', this.qrUrl.value]);
        break;
      case 2: // vcard
        value = this.parseQR(key, [
          '',
          this.qrVCname.value,
          this.qrVCorg.value,
          this.qrVCposition.value,
          this.qrVCtel.value,
          this.qrVCurl.value,
          this.qrVCmail.value,
          this.qrVCadr.value,
          this.qrVCmobile.value
        ]);
        break;
      case 3: // email
        value = this.parseQR(key, ['', this.qrMailTo.value, this.qrMailTopic.value, this.qrMailText.value]);
        break;
      case 4: // just text
        value = this.parseQR(key, ['', this.qrText.value]);
        break;
      default:
        value.src = 'https://www.creacheck.com';
        value.srcString = value.src;
        break;
    }

    src = value.src;
    srcString = value.srcString;
    // updateParam(id, attributes['data-name'], key+'#cc#'+srcString+'#cc#'+attributes['data-size'], errors);
    updateParam(
      id,
      attributes['data-name'],
      key +
        '#cc#' +
        srcString +
        '#cc#' +
        attributes['data-size'] +
        '#cc#' +
        this.state.QRBackgroundColor +
        '#cc#' +
        this.state.QRFontColor +
        '#cc#' +
        this.state.QRMargin,
      errors
    );
    this.setState({ showQRGen: false, src });
  };

  render() {
    const { name: Tag, attributes } = this.props;
    const { showQRGen, src, key, QRBackgroundColor, QRFontColor } = this.state;
    const {
      intl: { messages },
    } = this.props;


    let backColors = [];
    let fontColors = [];
    if(this.props.settings) {
      backColors = this.props.settings?.back_colors;
      fontColors = this.props.settings?.font_colors;
      backColors = backColors.concat(this.props.settings?.target?.back_colors);
      fontColors = fontColors.concat(this.props.settings?.target?.font_colors);
    }

    const qrValue = this.getSrc();
    return (
      <div className="wrap">
        <Tag {...attributes} onClick={this.openQRGen} data-tip="QR-Code einfügen" data-for="top">
          <QRCodeSVG
            value={qrValue}
            size={parseInt(attributes['data-size'])}
            bgColor={this.state.QRBackgroundColor}
            fgColor={this.state.QRFontColor}
            level="L"
            includeMargin={this.state.QRMargin}
          />
        </Tag>
        {showQRGen && (
          <ContextModal>
            <div id="contextModalWrap">
              <div id="contextModalStage" className="row">
                <h5>{messages.editor.content_of_QRCode}</h5>
                <div id="controlled-tab-qrcode">
                  <Tabs defaultActiveKey={key} onSelect={this.handleSelect} id="controlled-tab-qrcode-single-tab">
                    <Tab eventKey={1} title="URL">
                      <FormGroup as={Row} controlId="formURL">
                        <FormLabel column sm={12}>{messages.editor.address_of_website}</FormLabel>
                        <Col sm={12}>
                          <FormControl
                            type="text"
                            defaultValue={src.url}
                            placeholder="https://www.beispiel.de"
                            ref={ref => (this.qrUrl = ref)}
                            aria-describedby="urlHelpblock"
                          />
                          <FormText id="urlHelpBlock">{messages.editor.must_url}</FormText>
                        </Col>
                      </FormGroup>
                    </Tab>
                    <Tab eventKey={2} title={messages.editor.business_card}>
                      <FormGroup as={Row} controlId="formVC">
                        <FormLabel column sm={12}>{messages.editor.name_surname}</FormLabel>
                        <Col sm={12}>
                          <FormControl
                            type="text"
                            defaultValue={src.name}
                            placeholder="Max Mustermann"
                            ref={ref => (this.qrVCname = ref)}
                          />
                        <FormLabel column sm={12}>Firma</FormLabel>
                        </Col>
                        <FormControl
                          type="text"
                          defaultValue={src.org}
                          placeholder="Musterwerk GmbH"
                          ref={ref => (this.qrVCorg = ref)}
                        />
                        <FormLabel column sm={12}>{messages.editor.position}</FormLabel>
                        <FormControl
                          type="text"
                          defaultValue={src.title}
                          placeholder="Geschäftsführer"
                          ref={ref => (this.qrVCposition = ref)}
                        />
                        <FormLabel column sm={12}>{messages.editor.phone}</FormLabel>
                        <FormControl
                          type="text"
                          defaultValue={src.tel}
                          placeholder="+49 1234 56789"
                          ref={ref => (this.qrVCtel = ref)}
                        />
                        <FormLabel column sm={12}>{messages.mobile_phone}</FormLabel>
                        <FormControl
                          type="text"
                          defaultValue={src?.mobile}
                          placeholder="+49 160 111000"
                          ref={ref => (this.qrVCmobile = ref)}
                        />
                        <FormLabel column sm={12}>{messages.editor.website}</FormLabel>
                        <FormControl
                          type="text"
                          defaultValue={src.url}
                          placeholder="www.musterwerk.de"
                          ref={ref => (this.qrVCurl = ref)}
                        />
                        <FormLabel column sm={12}>{messages.editor.email}</FormLabel>
                        <FormControl
                          type="text"
                          defaultValue={src.mail}
                          placeholder="max.mustermann@musterwerk.de"
                          ref={ref => (this.qrVCmail = ref)}
                        />
                        <FormLabel column sm={12}>{messages.editor.address}</FormLabel>
                        <FormControl
                          type="text"
                          defaultValue={src.adr}
                          placeholder="Musterstr. 1, 01234 Musterhausen"
                          ref={ref => (this.qrVCadr = ref)}
                        />
                      </FormGroup>
                    </Tab>
                    <Tab eventKey={3} title={messages.editor.email_message}>
                      <FormGroup as={Row} controlId="formMail">
                        <FormLabel column sm={12}>{messages.editor.recipient_email_address}</FormLabel>
                        <Col sm={12}>
                          <FormControl
                            type="text"
                            defaultValue={src.mail}
                            placeholder="nur-ein@beispiel.de"
                            ref={ref => (this.qrMailTo = ref)}
                          />
                          <FormLabel column sm={12}>{messages.editor.reference}</FormLabel>
                        </Col>
                        <FormControl
                          type="text"
                          defaultValue={src.topic}
                          placeholder="Betreffzeile"
                          ref={ref => (this.qrMailTopic = ref)}
                        />
                        <FormLabel column sm={12}>{messages.editor.content}</FormLabel>
                        <FormControl
                          as="textarea"
                          defaultValue={src.text}
                          placeholder="Vordefinierter Text für die E-Mail"
                          ref={ref => (this.qrMailText = ref)}
                        />
                      </FormGroup>
                    </Tab>
                    <Tab eventKey={4} title={messages.editor.text}>
                      <FormGroup as={Row} controlId="formText">
                        <FormLabel column sm={12}>{messages.editor.your_text}</FormLabel>
                        <Col sm={12}>
                          <FormControl
                            as="textarea"
                            defaultValue={src.text}
                            placeholder="Text der erscheint, wenn Qr-Code gescannt wird..."
                            ref={ref => (this.qrText = ref)}
                          />
                        </Col>
                      </FormGroup>
                    </Tab>
                    <Tab eventKey={5} title={messages.editor.color}>
                      <div className="changeColorOptions">
                        <h3>{messages.editor.background_color}</h3>
                        <ButtonGroup className="edit-color QRBackground" size="small" vertical>
                          {backColors &&
                            backColors.map(bgColor => {
                              return (
                                <Button
                                  variant="light"
                                  data-tip={messages.editor.change_backgroundcolor}
                                  onClick={() => this.updateQRBackgroundColor(bgColor.color)}
                                  style={{ padding: 4 }}
                                >
                                  <p
                                    style={{ width: 30, height: 30, padding: 0, margin: 0, background: bgColor.color }}
                                  />
                                </Button>
                              );
                            })}
                          <Button
                            variant="light"
                            data-tip={messages.editor.change_backgroundcolor}
                            onClick={() => this.updateQRBackgroundColor('transparent')}
                            style={{ padding: 4 }}
                          >
                            <p style={{ width: 30, height: 30, padding: 0, margin: 0, background: 'transparent' }} />
                          </Button>
                        </ButtonGroup>
                        <h3>{messages.editor.color_of_qrcode}</h3>
                        <ButtonGroup className="edit-color QRFontColor" size="small" vertical>
                          {fontColors &&
                            fontColors.map(bgColor => {
                              return (
                                <Button
                                  variant="light"
                                  data-tip={messages.editor.change_backgroundcolor}
                                  onClick={() => this.updateQRFontColor(bgColor.color)}
                                  style={{ padding: 4 }}
                                >
                                  <p
                                    style={{ width: 30, height: 30, padding: 0, margin: 0, background: bgColor.color }}
                                  />
                                </Button>
                              );
                            })}
                        </ButtonGroup>
                        <div className="QRCodeMargin">
                          <FormSwitchery
                            name="margin"
                            label={messages.editor.distance_to_border}
                            value
                            checked={this.state.QRMarginCache}
                            onChange={this.updateQRMargin}
                          />
                        </div>
                        <div className="showQRExample">
                          <svg shape-rendering="crispEdges" height="150" width="150" viewBox="0 0 33 33">
                            <path fill={this.state.QRBackgroundColorCache} d="M0,0 h33v33H0z" />
                            <path
                              fill={this.state.QRFontColorCache}
                              d="M4 4h7v1H4zM14 4h1v1H14zM16 4h2v1H16zM20 4h1v1H20zM22,4 h7v1H22zM4 5h1v1H4zM10 5h1v1H10zM12 5h1v1H12zM14 5h1v1H14zM19 5h2v1H19zM22 5h1v1H22zM28,5 h1v1H28zM4 6h1v1H4zM6 6h3v1H6zM10 6h1v1H10zM16 6h1v1H16zM22 6h1v1H22zM24 6h3v1H24zM28,6 h1v1H28zM4 7h1v1H4zM6 7h3v1H6zM10 7h1v1H10zM12 7h3v1H12zM16 7h4v1H16zM22 7h1v1H22zM24 7h3v1H24zM28,7 h1v1H28zM4 8h1v1H4zM6 8h3v1H6zM10 8h1v1H10zM13 8h1v1H13zM20 8h1v1H20zM22 8h1v1H22zM24 8h3v1H24zM28,8 h1v1H28zM4 9h1v1H4zM10 9h1v1H10zM12 9h2v1H12zM15 9h2v1H15zM18 9h3v1H18zM22 9h1v1H22zM28,9 h1v1H28zM4 10h7v1H4zM12 10h1v1H12zM14 10h1v1H14zM16 10h1v1H16zM18 10h1v1H18zM20 10h1v1H20zM22,10 h7v1H22zM13 11h3v1H13zM18 11h2v1H18zM4 12h5v1H4zM10 12h4v1H10zM15 12h1v1H15zM17 12h3v1H17zM21 12h1v1H21zM23 12h1v1H23zM25 12h1v1H25zM27 12h1v1H27zM4 13h4v1H4zM11 13h2v1H11zM14 13h1v1H14zM16 13h1v1H16zM20 13h2v1H20zM23 13h1v1H23zM27 13h1v1H27zM6 14h2v1H6zM9 14h2v1H9zM14 14h1v1H14zM17 14h1v1H17zM19 14h7v1H19zM27,14 h2v1H27zM4 15h1v1H4zM6 15h1v1H6zM8 15h1v1H8zM12 15h1v1H12zM16 15h1v1H16zM18 15h4v1H18zM23 15h1v1H23zM28,15 h1v1H28zM5 16h2v1H5zM8 16h1v1H8zM10 16h2v1H10zM13 16h2v1H13zM16 16h4v1H16zM21 16h4v1H21zM26,16 h3v1H26zM4 17h1v1H4zM6 17h1v1H6zM8 17h2v1H8zM11 17h2v1H11zM17 17h1v1H17zM20 17h2v1H20zM23 17h1v1H23zM25 17h1v1H25zM27 17h1v1H27zM4 18h1v1H4zM10 18h2v1H10zM13 18h5v1H13zM19 18h1v1H19zM21 18h5v1H21zM27,18 h2v1H27zM4 19h1v1H4zM7 19h2v1H7zM12 19h2v1H12zM15 19h1v1H15zM18 19h1v1H18zM21 19h1v1H21zM23 19h2v1H23zM28,19 h1v1H28zM4 20h1v1H4zM6 20h1v1H6zM9 20h3v1H9zM15 20h3v1H15zM19 20h6v1H19zM26 20h1v1H26zM12 21h1v1H12zM14 21h1v1H14zM16 21h2v1H16zM20 21h1v1H20zM24 21h2v1H24zM4 22h7v1H4zM12 22h3v1H12zM17 22h2v1H17zM20 22h1v1H20zM22 22h1v1H22zM24 22h1v1H24zM26,22 h3v1H26zM4 23h1v1H4zM10 23h1v1H10zM20 23h1v1H20zM24 23h2v1H24zM27,23 h2v1H27zM4 24h1v1H4zM6 24h3v1H6zM10 24h1v1H10zM12 24h1v1H12zM15 24h10v1H15zM26 24h1v1H26zM4 25h1v1H4zM6 25h3v1H6zM10 25h1v1H10zM12 25h2v1H12zM15 25h1v1H15zM20 25h1v1H20zM22 25h1v1H22zM24,25 h5v1H24zM4 26h1v1H4zM6 26h3v1H6zM10 26h1v1H10zM12 26h2v1H12zM17 26h1v1H17zM19 26h1v1H19zM25 26h2v1H25zM28,26 h1v1H28zM4 27h1v1H4zM10 27h1v1H10zM12 27h1v1H12zM14 27h2v1H14zM18 27h4v1H18zM23 27h3v1H23zM28,27 h1v1H28zM4 28h7v1H4zM12 28h1v1H12zM14 28h5v1H14zM23,28 h6v1H23z"
                            />
                          </svg>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
                {this.state.key !== 5 ? (
                  <Button className="cm-max-width" variant="success" size="lg" onClick={this.generateQR}>
                    {messages.editor.add_QRCode}
                  </Button>
                ) : (
                  <Button
                    variant="success"
                    size="large"
                    onClick={() => this.changeQRCodeColor()}
                    className="cancelIE changeQRCodeColor"
                  >
                    {messages.editor.take_on}
                  </Button>
                )}
                <Button variant="danger" size="large" onClick={this.handleQRclose} className="cancelIE">
                  {messages.editor.abort}
                </Button>
              </div>
            </div>
          </ContextModal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(QRCodeElement)));
